import { render, staticRenderFns } from "./AdminModalsManager.vue?vue&type=template&id=74b1ac70&scoped=true&"
import script from "./AdminModalsManager.vue?vue&type=script&lang=js&"
export * from "./AdminModalsManager.vue?vue&type=script&lang=js&"
import style0 from "./AdminModalsManager.vue?vue&type=style&index=0&id=74b1ac70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b1ac70",
  null
  
)

export default component.exports